// Block spans arrive either as {"blockId":"/page/4/Table/2"} JSON or the raw
// block path; the page segment in block paths is 0-based. Shared by every
// surface that deep-links the document viewer from a source reference.
export function parseSpan(span) {
    if (!span) return {
        blockId: undefined,
        page: null
    };
    let blockId = span.trim();
    try {
        const parsed = JSON.parse(span);
        if (parsed && typeof parsed.blockId === 'string') blockId = parsed.blockId;
    } catch  {
    // raw path form
    }
    const m = blockId.match(/^\/page\/(\d+)\//);
    if (!m) return {
        blockId: blockId.startsWith('/') ? blockId : undefined,
        page: null
    };
    return {
        blockId,
        page: Number(m[1]) + 1
    };
}
